import { StoreReport } from "../../../../../core";
import { statusPicking } from "../../../../../core/configs/statusOfPicking";

export const storeReport = {
  classValidation: (row: any) => {
    if (row.state.toUpperCase() === 'CANCELADO') {
      return 'pending';
    }
    return '';
  },
  searchText: '',
  sort: true,
  dialogHability: true,
  filter: false,
  paginator: true,
  checkbox: false,
  export: true,
  exportAllData: true,
  exportFile: 'reporte_retiro_tienda.xlsx',
  expandable: false,
  disabled: false,
  partialField: '',
  columns: [
    {
      title: 'Sucursal de entrega',
      name: 'dispatchEntity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.deliveryEntity
    },
    {
      title: 'Estatus de Despacho',
      name: 'stateDispatch',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.state
    },
    {
      title: 'Estatus de Retiro',
      name: 'stateProduct',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.stateProduct
    },
    {
      title: 'Código de N/V',
      name: 'nvCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: StoreReport) => element.orderNumber
    },
    {
      title: 'Código de despacho',
      name: 'dispatchCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.dispatchNumber
    },
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.skuCode
    },
    {
      title: 'LPN',
      name: 'lpn',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.lpnNumber
    },
    {
      title: 'Descripción - SKU',
      name: 'productDescription',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.productDescription
    },
    {
      title: "Tipo de mercadería",
      name: "typeOfMerchandise",
      type: "string",
      visible: true,
      class: "center",
      value: (element: StoreReport) => element.division,
    },
    {
      title: 'Cantidad total',
      name: 'totalQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.totalQuantity
    },
    {
      title: 'Cantidad entregada',
      name: 'deliveryQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.deliveryQuantity
    },
    {
      title: 'Cantidad pendiente',
      name: 'pendingQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.pendingQuantity
    },
    {
      title: 'Cantidad devuelta',
      name: 'returnedQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.returnedQuantity
    },
    {
      title: 'Cantidad cancelada',
      name: 'cancelledQuantity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.cancelledQuantity
    },
    {
      title: 'Fecha de devolución',
      name: 'returnStatusDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.returnStatusDate
    },
    {
      title: 'Fecha de devolución a seller',
      name: 'returnSellerStatusDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.returnSellerStatusDate
    },
    {
      title: 'Fecha comprometida al cliente',
      name: 'deliveryDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.programmedDeliveryDate
    },
    {
      title: 'Fecha de recepción en entidad final',
      name: 'finalEntityArrivalDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.finalEntityArrivalDate
    },
    {
      title: 'Fecha/Hora de ubicación',
      name: 'locationDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.locationDate
    },
    {
      title: 'Courier',
      name: 'courrierName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.courrierName
    },
    {
      title: 'Fecha real de entrega',
      name: 'realDispatchDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.withdrawDate
    },
    {
      title: 'Nro de ubicación',
      name: 'locationNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.locationNumber ? element.locationNumber
        : (element.locationLpn
          && (element.stateProduct.toUpperCase() === statusPicking.warehouse || element.stateProduct.toUpperCase() === statusPicking.delivered
            || element.stateProduct.toUpperCase() === statusPicking.deliveredPending)
          ? element.locationLpn : '')
    },
    {
      title: 'Teléfono',
      name: 'contactPhone',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.contactPhone
    },
    {
      title: 'Email',
      name: 'contactEmail',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.contactEmail
    },
    {
      title: 'Nro. de documento de cliente',
      name: 'customerDocument',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.customerDocument
    },
    {
      title: 'Nombre de cliente',
      name: 'customerName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.customerName
    },
    {
      title: 'Documento de persona que retira',
      name: 'withdrawPersonDocument',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.withdrawPersonDocument
    },
    {
      title: 'Nombre de persona que retira',
      name: 'withdrawPerson',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.withdrawPerson
    },
    {
      title: 'Sucursal de origen de stock',
      name: 'originEntity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: StoreReport) => element.originEntity
    },
    {
      title: 'Fecha de vigencia de retiro',
      name: 'withdrawalEffectiveDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: StoreReport) => element.withdrawalEffectiveDate
    },
    {
      title: 'Motivo de cancelación',
      name: 'reasonCancellation',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: StoreReport) => element.reasonCancellation
    },
    /*{
      title: 'Sucursal de venta',
      name: 'saleEntity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: StoreReport) => element.entityName
    }*/
    {
      title: 'Canal de Venta',
      name: 'channel',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: StoreReport) => element.channel
    },
    {
      title: 'Tipo de Despacho',
      name: 'deliveryAgreement',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: StoreReport) => element.deliveryAgreement
    }
    ,
    {
      title: 'Motivo de devolución',
      name: 'reasonForReturn',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: StoreReport) => {
        let reasonForReturn;
        if (element.listReasonForReturn && element.reasonForReturn) {
          reasonForReturn = element.listReasonForReturn.find(listReason => {
            return listReason.configName === element.reasonForReturn;
          });
        }
        return reasonForReturn ? reasonForReturn.configValue : "";
      }
    },
    {
      title: 'Comentario',
      name: 'comments',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: StoreReport) => element.scomments
    },
    {
      title: 'Sucursal Actual',
      name: 'currentEntity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: StoreReport) => element.currentEntity
    },
    {
      title: 'Agrupación de entidad inicial',
      name: 'originGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.originGroupName
    },
    {
      title: 'Agrupación de entidad final',
      name: 'finalGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: StoreReport) => element.finalGroupName
    }
  ]
}
